import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { StandardBannerSectionProps } from '../../../components/sections/StandardBannerSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { StandardBannerContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<StandardBannerSectionProps> =
  dynamic<StandardBannerSectionProps>(() =>
    import('../../../components/sections/StandardBannerSection').then(
      (mod) => mod.StandardBannerSection,
    ),
  );

export const transformer: Transformer<StandardBannerContentSection, StandardBannerSectionProps> = (
  { _metadata, background_color, image, heading, copy, cta, tracking_title },
  { positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    heading: heading,
    backgroundColor: background_color,
    images: getContentstackImagesForWidths(image.image_source.url, [360, 500, 700, 900, 1132], {
      aspectRatio: '16:9',
    }),
    imageWidth: 360,
    imageHeight: 216,
    imageAlt: image.alt_text,
    copy: copy || '',
    linkHref: cta?.href || '',
    linkText: cta?.title || '',
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
